import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export type EnviarPropostaCompatibilidadeResponse = {
  criada: boolean;
  jaExistia: boolean;
  compatibilidadeId: number;
  solicitacaoReservaId?: number;
  token?: string;
  valorDisponivel?: number | string | null;
  valorPropostoClienteInicial?: number | string | null;
  dataCheckin?: string;
  dataCheckout?: string;
  contato?: string | null;
  nome?: string | null;
  sobrenome?: string | null;
  celular?: string | null;
  email?: string | null;
  motivo?: string | null;
  statusAtual?: string | null;
};

export const enviarPropostaCompatibilidadeService = async (
  compatibilidadeId: number
): Promise<EnviarPropostaCompatibilidadeResponse | false> => {
  const Token = validateToken();

  if (!Token) {
    return false;
  }

  const URL = `${Globais.DOMINIOBACK}/compatibilidades/${compatibilidadeId}/solicitacao-reserva`;

  try {
    const response = await axios.post(URL, undefined, {
      headers: { Authorization: Token.AuthStr },
    });

    if (response && response.data) {
      return response.data;
    }

    return false;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.data) {
      return error.response.data as EnviarPropostaCompatibilidadeResponse;
    }

    console.error(error);
    throw error;
  }
};
